import helpers from './helpers';
import sliders from './components/sliders';
import tabs from './components/tabs';
import ages from './components/ages';
import header from './components/header';

function init() {
	sliders.init();
	tabs.init();
	ages.init();
	header.init();

	$('.footer__button').on('click', () => {
		helpers.scrollTo(helpers.$body);
	});
}

init();
